<template>
    <el-container>
        <el-header style="height:auto">
            <el-form :inline="true" :model="fromUser" ref="fromUser" class="demo-form-inline" :rules="rules">
                <el-row :gutter="20">
<!--                    <td-permission :roles="roles" style="float:right;">-->
<!--                        <div slot="havePermission">-->
<!--                            <el-form-item :label="$t('common.CURSYS')">-->
<!--                                <td-select-->
<!--                                    v-model="sysFlg"-->
<!--                                    :placeholder="$t('common.PLEASE_SELECT')"-->
<!--                                    @change="queryPageBySys()"-->
<!--                                    :options="this.sysAndFlgList"-->
<!--                                    keys="sSysFlg"-->
<!--                                    text="sName"-->
<!--                                    :clearable="false"-->
<!--                                >-->
<!--                                </td-select>-->
<!--                            </el-form-item>-->
<!--                        </div>-->
<!--                    </td-permission>-->
                    <td-permission :permissions="permissionsView" style="display:auto;">
                        <div slot="havePermission" class="divClass">
                            <el-form-item :label="$t('common.USERNAME')">
                                <td-input placeholder="common.PLEASE_INPUT" v-model="fromUser.sName"></td-input>
                            </el-form-item>
                            <el-form-item :label="$t('common.ROLENAME')">
                                <td-input placeholder="common.PLEASE_INPUT" v-model="fromUser.roleName"></td-input>
                            </el-form-item>
                            <el-form-item :label="$t('common.RESTYPENAME')">
                                <td-input placeholder="common.PLEASE_INPUT" v-model="fromUser.resName"></td-input>
                            </el-form-item>
                            <el-form-item :label="$t('common.AUTH_NAME')">
                                <td-input placeholder="common.PLEASE_INPUT" v-model="fromUser.authName"></td-input>
                            </el-form-item>
                            <el-form-item style="padding-left:10px">
                                <td-button type="primary" :permissions="permissionsView" :loading="loading" @click.native="queryPageList">{{ $t('common.SEARCH') }}</td-button>
                                <td-button type="button" :permissions="permissionsView" @click.native="btnReset">{{ $t('common.RESET') }}</td-button>
                            </el-form-item>
                        </div>
                    </td-permission>
                </el-row>
                <el-row>
                    <el-form-item>
                        <td-button type="button" :permissions="permissionsAdd" @click.native="btnAddUser">{{ $t('common.ADD') }}</td-button>
                        <td-button type="button" :permissions="permissionsImport" @click.native="btnUploadExcel">{{ $t('common.IMPORT') }}</td-button>
                        <td-button type="button" :permissions="permissionsExport" @click.native="btnExportExcel">{{ $t('common.EXPORT') }}</td-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :permissions="permissionsView"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :hasMutiSelect="false"
                :orgTreeUrl="orgTreeUrl"
                :hasLoading="loading"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                rowKey="userId"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-UserInfo
                v-if="dialogUserVisible"
                :isAddData="isAddData"
                :dialogUserVisible="dialogUserVisible"
                :sysFlg="sysFlg"
                :sysList="sysList"
                :roleInfoList="roleInfoList"
                :editItem="editItem"
                :title="title"
                ref="addOrModifyInfo"
                @userDialogClose="userDialogClose"
                @submit="submit"
            ></dialog-UserInfo>
            <dialog-upload-excel
                v-if="dialogUploadExcelVisible"
                :dialogUploadExcelVisible="dialogUploadExcelVisible"
                :sysFlg="sysFlg"
                :title="title"
                ref="uploadExcel"
                @uploadExcelDialogClose="uploadExcelDialogClose"
                @submit="submit"
            ></dialog-upload-excel>
            <dialog-user-detail
                v-if="dialogUserDetailVisible"
                :title="title"
                :dialogUserDetailVisible="dialogUserDetailVisible"
                :sysFlg="sysFlg"
                :editItem="editItem"
                ref="showUserDetail"
                @userDetailDialogClose="userDetailDialogClose"
            ></dialog-user-detail>
            <dialog-copy-authority
                v-if="dialogCopyAuthorityVisible"
                :sysFlg="sysFlg"
                :editItem="editItem"
                :dialogVisible="dialogCopyAuthorityVisible"
                @dialogClose="dialogCopyAuthorityClose"
            ></dialog-copy-authority>
        </el-main>
    </el-container>
</template>

<script>
import dialogUserInfo from './components/dialogUserInfo.vue';
import dialogUploadExcel from './components/dialogUploadExcel.vue';
import dialogUserDetail from './components/dialogUserDetail.vue';
import dialogCopyAuthority from './components/dialogCopyAuthority.vue';
import resourceApi from './assets/api.js';
export default {
    // 初始化渲染
    components: {
        'dialog-UserInfo': dialogUserInfo,
        'dialog-upload-excel': dialogUploadExcel,
        'dialog-user-detail': dialogUserDetail,
        'dialog-copy-authority': dialogCopyAuthority
    },
    created() {
        if (this.$common.systemInfo.systemId) {
            this.sysFlg = this.$common.systemInfo.systemId;
        } else {
            this.sysFlg = 'PG';
        }

        let param = {};
        resourceApi.getSysList(JSON.stringify(param), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                // this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('sys/getSysList', response.data.statusMessage);
            }
            this.sysList = response.data.content;
            this.sysAndFlgList = [];
            for (let index = 0; index < this.sysList.length; index++) {
                let element = this.sysList[index];
                this.sysAndFlgList.push({ sName: element.sName + '：' + element.sSysFlg, sSysFlg: element.sSysFlg });
            }
            // this.getMenuUrl();
        });
        let params = {
            sTag: 'SYSTEM_USERS'
        };
        resourceApi.getDictValuesByTag(params, response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$log.error('/setting/dictController/getDictValuesByTag', response.data.statusMessage);
            }
            this.systemUsers = [];
            if (response.data.content) {
                for (let index in response.data.content) {
                    if (response.data.content[index].sCode) {
                        this.systemUsers.push(response.data.content[index].sCode);
                    }
                }
            }
        });
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.queryPageList(); // 进行页面初始化数据的加载
    },
    // 定义数据
    data() {
        return {
            //角色信息list
            roleInfoList: [],
            fromUser: {
                sName: '',
                resName: '',
                roleName: '',
                authName: '',
                iLockType: ''
            },
            editItem: '',
            sysFlg: '',
            permissionsAdd: ['userInfo:add'],
            permissionsEdit: ['userInfo:edit'],
            permissionsView: ['userInfo:view'],
            permissionsDel: ['userInfo:del'],
            permissionsImport: ['userInfo:import'],
            permissionsExport: ['userInfo:export'],
            permissionsCopyAuth: ['userInfo:copyAuth'],
            systemUsers: [],
            sysList: [],
            sysAndFlgList: [],
            orgList: [],
            orgTreeUrl: '',
            dialogUserVisible: false,
            dialogUploadExcelVisible: false,
            dialogUserDetailVisible: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            // 对表单进行数据验证
            rules: {
                sName: [
                    {
                        pattern: this.$regex.USERCAPTION_RULE,
                        message: this.$t('error.ERROR_USER_CAPTION_ILLEGAL')
                    }
                ],
                roleName: [
                    {
                        pattern: this.$regex.ROLECAPTION_RULE,
                        message: this.$t('error.ERROR_ROLE_CAPTION_ILLEGAL')
                    }
                ],
                authName: [
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                resName: [
                    {
                        pattern: this.$regex.USERCAPTION_RULE,
                        message: this.$t('error.ERROR_RES_CAPTION_ILLEGAL')
                    }
                ]
            },
            columns: [
                {
                    prop: 'userName',
                    label: this.$t('common.USERNAME')
                },
                // , {
                //     prop: 'userDescription',
                //     label: this.$t('common.DESCRIPTION')
                // }
                {
                    prop: 'roleName',
                    label: this.$t('common.USERROLE')
                    // ,
                    // render: (createElement, params) => {
                    //     let roleList = params.row.roleList
                    //     let node
                    //     for (let i = 0; i < roleList.length; i++) {
                    //         node += '<span>' + roleList[i].role + '</span>'
                    //     }
                    //     return node
                    // }
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    tableWidth: '230',
                    align: 'center',
                    render: (createElement, params) => {
                        let result = [];
                        let lockName = this.$t('common.LOCK');
                        if (params.row.iLockType === 0) {
                            lockName = this.$t('common.LOCK');
                        } else {
                            lockName = this.$t('common.UNLOCK');
                        }
                        // let per = this.permissions;
                        let editBtn = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                on: {
                                    click: () => {
                                        this.btnEdit(params.row);
                                    }
                                }
                            },
                            this.$t('common.EDIT')
                        );
                        let delBtn = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                on: {
                                    click: () => {
                                        this.btnDelete(params.row.userId);
                                    }
                                }
                            },
                            this.$t('common.DELETE')
                        );
                        let copyAuthBtn = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsCopyAuth, type: 'text', size: 'small' },
                                on: {
                                    click: () => {
                                        this.btnCopyAuthority(params.row);
                                    }
                                }
                            },
                            this.$t('userInfo.COPY_AUTHORITY')
                        );
                        let lockBtn = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                on: {
                                    click: () => {
                                        this.btnLock(params.row);
                                    }
                                }
                            },
                            lockName
                        );
                        let detailBtn = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsView, type: 'text', size: 'small' },
                                on: {
                                    click: () => {
                                        this.btnShowDetail(params.row);
                                    }
                                }
                            },
                            this.$t('common.DETAIL')
                        );
                        if (this.systemUsers.indexOf(params.row.userId) < 0) {
                            result.push(editBtn);
                            result.push(delBtn);
                            result.push(copyAuthBtn);
                            result.push(lockBtn);
                        }
                        result.push(detailBtn);
                        return createElement('div', result);
                    }
                }
            ],
            dialogCopyAuthorityVisible: false
        };
    },
    // 方法的实现
    methods: {
        // 根据user的id显示对应的类型名称
        formatterType(row) {
            switch (row.iType) {
                case 0:
                    return this.$t('common.RABBITMQ');
                // break
                default:
                    return this.$t('common.UNKNOW_TYPE');
            }
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.submit();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        // 查询数据
        queryPageList() {
            this.currentPage = 1;
            this.btnQuery();
        },
        queryPageBySys() {
            this.currentPage = 1;
            if (this.sysFlg !== 'nextPageValue' && this.sysFlg !== 'lastPageValue') {
                this.btnQuery();
            }
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                userName: this.fromUser.sName,
                resName: this.fromUser.resName,
                roleName: this.fromUser.roleName,
                authName: this.fromUser.authName,
                sSysFlg: this.sysFlg,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            resourceApi.listUserInfos(param, response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getAllUsers', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 添加
        btnAddUser() {
            this.getAllRoleByType();
            this.title = this.$t('common.ADD_USER'); // 标题
            this.isAddData = true;
            this.dialogUserVisible = true;
            this.orgTreeUrl = this.hostUrl + this.deptUrl;
        },
        // 编辑
        btnEdit(row) {
            this.isAddData = false;
            this.editItem = row;
            this.getAllRoleByType();
            this.title = this.$t('common.EDIT_USER');
            this.dialogUserVisible = true;
            this.orgTreeUrl = this.hostUrl + this.deptUrl;
        },
        // 删除接口
        btnDelete(userId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = {
                        sId: userId,
                        sysFlg: this.sysFlg
                    };
                    resourceApi.deleteUserInfo(param, response => {
                        if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                            this.$message({ showClose: true, message: response.data.message, type: 'error' });
                            this.$log.error('user/deleteUserInfo', response.data.message);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'))
                    this.$log.error('user/deleteUserInfo---- Fail');
                });
        },
        btnLock(row) {
            let lockType = row.iLockType;
            let msg = this.$t('common.LOCK_INFO_TIPS');
            if (lockType === 0) {
                lockType = 1;
                msg = this.$t('common.LOCK_INFO_TIPS');
            } else {
                lockType = 0;
                msg = this.$t('common.UN_LOCK_INFO_TIPS');
            }

            this.$confirm(msg, this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = {
                        sId: row.userId,
                        lockUserOnly: true,
                        iLockType: lockType
                    };
                    resourceApi.updateUserInfo(param, response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.message, type: 'error' });
                            this.$log.error('user/updateUserInfo', response.data.message);
                            return;
                        }
                        if (lockType === 1) {
                            this.$message({ showClose: true, message: this.$t('common.LOCK_SUCCESS'), type: 'success' });
                        } else {
                            this.$message({ showClose: true, message: this.$t('common.UNLOCK_SUCCESS'), type: 'success' });
                        }

                        this.submit();
                    });
                })
                .catch(() => {
                    this.$log.error('user/lockUserInfo---- Fail');
                });
        },
        getMenuUrl() {
            let arr = this.sysList;
            for (let index in arr) {
                if (arr[index].sSysFlg === this.sysFlg) {
                    this.menuUrl = arr[index].sMenuUrl;
                    this.hostUrl = arr[index].sUrl;
                    this.deptUrl = arr[index].sDeptUrl;
                }
            }
            let param = {};

            if (this.deptUrl !== '') {
                resourceApi.getOrgList(this.deptUrl, this.hostUrl, JSON.stringify(param), response => {
                    if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error(this.hostUrl + this.deptUrl, response.data.statusMessage);
                        return;
                    }

                    let deptData = response.data.content;
                    this.orgList = deptData;
                    // console.log(this.orgList)
                });
            }
        },
        //查询角色信息按角色类型分组
        getAllRoleByType() {
            resourceApi.getAllRoleByType(response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getAllRoleByType', response.data.statusMessage);
                    return;
                }
                this.roleInfoList = response.data.content;
                //初始化用户选中角色
                if (!this.isAddData) {
                    this.initRoleCheckState();
                }
            });
        },
        initRoleCheckState() {
            if (this.editItem == '') {
                return;
            }
            let userId = this.editItem.id;
            let formData = new FormData();
            formData.append('userId', userId);
            resourceApi.getCheckedRole(formData, response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getCheckedRole', formData, response.data.statusMessage);
                    return;
                }
                let checkedRoleList = response.data.content;
                for (let i = 0; i < this.roleInfoList.length; i++) {
                    const element = this.roleInfoList[i];
                    for (let j = 0; j < checkedRoleList.length; j++) {
                        const checkedElement = checkedRoleList[j];
                        if (element.orgFlg == checkedElement.orgFlg) {
                            element.checkRoleIdList.push(checkedElement.id);
                        }
                    }
                }
            });
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // 关闭页面
        userDialogClose() {
            this.dialogUserVisible = false;
        },
        // 关闭页面
        userDetailDialogClose() {
            this.dialogUserDetailVisible = false;
        },
        // 导入Excel
        btnUploadExcel() {
            this.title = this.$t('common.IMPORT'); // 标题
            this.dialogUploadExcelVisible = true;
        },

        decodeUTF8(arr) {
            var str = '';
            for (var i = 0; i < arr.length; i++) {
                str += String.fromCharCode(arr[i]);
            }
            return decodeURIComponent(escape(str));
        },
        // 导出Excel
        btnExportExcel() {
            let param = {
                userName: this.fromUser.sName,
                resName: this.fromUser.resName,
                roleName: this.fromUser.roleName,
                authName: this.fromUser.authName,
                sSysFlg: this.sysFlg
            };

            let responseType = 'arraybuffer';
            resourceApi.exportExcel(param, responseType, response => {
                let _response = response;
                try {
                    _response = JSON.parse(this.decodeUTF8(new Uint8Array(response.data)));
                    if (_response.statusCode) {
                        if (_response.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: _response.statusMessage, type: 'error' });
                            return;
                        }
                    }
                } catch (e) {
                    //返回类型不是json说明调用成功，直接导出文件
                }

                this.$log.info('btnExport response ', response);
                let blob = new Blob([response.data], { type: 'application/x-xls' });
                this.content = response.data;
                // 汉子解码
                let filename = decodeURIComponent(response.headers['filename']);

                if (window.navigator.msSaveOrOpenBlob) {
                    // 兼容IE10
                    navigator.msSaveBlob(blob, filename);
                } else {
                    //  chrome/firefox
                    let aTag = document.createElement('a');
                    aTag.download = filename;
                    aTag.href = window.URL.createObjectURL(blob);
                    aTag.click();
                    URL.revokeObjectURL(aTag.href);
                }
                this.$message({ showClose: true, message: this.$t('common.EXPORTSUCESSE'), type: 'success' });
            });
        },
        // 关闭页面
        uploadExcelDialogClose() {
            this.submit();
            this.dialogUploadExcelVisible = false;
        },
        // 显示详情
        btnShowDetail(row) {
            this.editItem = row;
            this.title = this.$t('common.DETAIL'); // 标题
            this.dialogUserDetailVisible = true;
        },
        btnCopyAuthority(row) {
            this.editItem = row;
            this.dialogCopyAuthorityVisible = true;
        },
        dialogCopyAuthorityClose() {
            this.dialogCopyAuthorityVisible = false;
            this.submit();
        },
        //重置
        btnReset(){
            this.fromUser.sName = '';
            this.fromUser.resName = '';
            this.fromUser.roleName = '';
            this.fromUser.authName = '';
        }
    }
};
</script>
<style scoped>
.divClass {
    padding-left: 10px;
}
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
